import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timetableResults" }

import {
  computed,
  onMounted, ref, watch, watchEffect,
} from 'vue';
import {
  DatePickerCarousel,
  TimetableSearchResults,
  PortPairSailing,
} from '../../index';
import { useTimetableStore } from '../../stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableResultView',
  props: {
    from: {},
    to: {},
    fromDate: {},
    reinitDatepickerCarousel: { type: Boolean },
    isWebView: { type: Boolean }
  },
  emits: ['updateSearchResults', 'toggleSwiper', 'getSailingResults'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const timetableStore = useTimetableStore();
const sailings = ref<PortPairSailing[] | undefined>(timetableStore.getSailingResults);

const isLoading = ref<boolean>(false);

const isError = computed(() => timetableStore.isServerError);

const viewState = ref({
  search: {
    from: props.from,
    to: props.to,
    fromDate: props.fromDate,
  },
});

const getResults = async (newDate = undefined) => {
  if (newDate) {
    emit('updateSearchResults', newDate);
  }

  // if results have already been fetched for this date populate the sailings
  if (timetableStore.timetableSearchResults) {
    sailings.value = timetableStore.getSailingResults;
  }
};

onMounted(() => {
  getResults();
});

watchEffect(() => {
  isLoading.value = timetableStore.isLoading;
});

watch(() => timetableStore.getSailingResults, (results) => {
  if (results) {
    sailings.value = results;
    emit('getSailingResults', sailings.value);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DatePickerCarousel), {
      "initial-date": _ctx.fromDate,
      "reinitialise-swiper": _ctx.reinitDatepickerCarousel,
      onUpdateDate: _cache[0] || (_cache[0] = (newDate) => getResults(newDate)),
      onToggleInitSwiper: _cache[1] || (_cache[1] = (isInit) => _ctx.$emit('toggleSwiper', isInit))
    }, null, 8, ["initial-date", "reinitialise-swiper"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(TimetableSearchResults), {
        sailings: sailings.value,
        "is-loading": isLoading.value,
        "is-error": isError.value
      }, null, 8, ["sailings", "is-loading", "is-error"])
    ])
  ], 64))
}
}

})